import { Link } from "react-router-dom";

export const ProductCard = ({ p, index = 0 }) => (
  <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`}
    className="group block animate-fade-up" style={{ animationDelay: `${Math.min(index, 6) * 70}ms` }}>
    <div className="relative overflow-hidden bg-luxa-sand aspect-[4/5]">
      <img src={p.images?.[0]} alt={p.name} loading="lazy" className="img-zoom w-full h-full object-cover" />
      {p.stock === 0 && (
        <span className="absolute top-4 right-4 bg-luxa-cream text-luxa-espresso overline px-3 py-1">Sold Out</span>
      )}
    </div>
    <div className="mt-4 flex items-start justify-between gap-4">
      <div>
        <p className="overline text-luxa-espresso/40">{p.category}</p>
        <h3 className="font-serif text-xl mt-1 group-hover:text-luxa-gold transition-colors duration-300">{p.name}</h3>
      </div>
    </div>
  </Link>
);

export const SectionLabel = ({ children }) => (
  <p className="overline text-luxa-brown flex items-center gap-3">
    <span className="w-8 h-px bg-luxa-gold" aria-hidden="true" />{children}
  </p>
);
